import styled from 'styled-components';

export const CustomSkeleton = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    & div {
        margin: 20px;
        width: 100% !important;
        span {
            width: 100% !important;
        }
    }
`;
